import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getVehicleTypes } from "../../../actions/admin/vehicletype";
import VehicleTypeItem from "./VehicleTypeItem";
import Spinner from "../../layout/Spinner";
import AdminPage from "../_components/AdminPage";
import AdminCreateButton from "../_components/AdminCreateButton";

const VehicleTypeList = () => {
  const vehicleType = useSelector((state) => state.vehicletype);
  const { loading, vehicletypes } = vehicleType;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getVehicleTypes());
  }, [dispatch]);

  return (
    <AdminPage title="Vehicle Type List" actions={<AdminCreateButton to="/admin/addvehicletype" label="Add Vehicle Type" />}>
      <div className="tw:mt-[20px]">
        {loading ? (
          <Spinner />
        ) : (
          <div className="container-fluid">
            <div className="row">
              {vehicletypes.map((vt, i = 0) => (
                <VehicleTypeItem key={vt._id} vehicletypes={vt} count={i++} />
              ))}
            </div>
          </div>
        )}
      </div>
    </AdminPage>
  );
};

export default VehicleTypeList;
